import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'
import _imports_1 from '@/assets/images/date-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1484629a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container m-8 bg-fff" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Dealer Status Tracking")
], -1))
const _hoisted_3 = { class: "payment-overview-block-wrapper" }
const _hoisted_4 = { class: "payment-overview-block" }
const _hoisted_5 = { class: "payment-search-wrapper" }
const _hoisted_6 = { class: "payment-search-row" }
const _hoisted_7 = { class: "search-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Year ", -1))
const _hoisted_9 = { class: "search-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Month ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "search-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Payout Round ", -1))
const _hoisted_14 = { class: "search-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Entity ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_17 = { class: "search-btn" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_21 = { class: "payment-overview-block" }
const _hoisted_22 = { class: "control-wrapper" }
const _hoisted_23 = { class: "collapse-wrapper" }
const _hoisted_24 = {
  class: "collapse-icon-wrapper",
  style: {"padding":"5px","background":"white","border-radius":"20px"}
}
const _hoisted_25 = { class: "collapse-header-wrapper" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-header-title" }, " Risk Dealer ", -1))
const _hoisted_27 = { class: "collapse-header-data" }
const _hoisted_28 = { class: "collapse-header-data-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "light-color count-title" }, " Total Amount w/o VAT ", -1))
const _hoisted_30 = { class: "collapse-header-data-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "light-color count-title" }, " Total Amount w VAT ", -1))
const _hoisted_32 = { class: "collapse-header-wrapper" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-header-title" }, " Normal Dealer ", -1))
const _hoisted_34 = { class: "collapse-header-data" }
const _hoisted_35 = { class: "collapse-header-data-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "light-color count-title" }, " Total Amount w/o VAT ", -1))
const _hoisted_37 = { class: "collapse-header-data-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "light-color count-title" }, " Total Amount w VAT ", -1))
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YearPicker = _resolveComponent("YearPicker")!
  const _component_a_month_picker = _resolveComponent("a-month-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_entity_selector = _resolveComponent("entity-selector")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_collapse_table = _resolveComponent("collapse-table")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_YearPicker, {
                value: _ctx.query.year,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.year) = $event)),
                class: "sel-inp-size",
                allowClear: false,
                placeholder: "Please select",
                onPanelChange: _cache[1] || (_cache[1] = () => _ctx.searchRound())
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_a_month_picker, {
                value: _ctx.query.month,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.month) = $event)),
                placeholder: "Please select",
                format: "MMM",
                class: "sel-inp-size",
                allowClear: false,
                onChange: _ctx.searchRound
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_a_select, {
                allowClear: "",
                value: _ctx.query.payoutRound,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.payoutRound) = $event)),
                class: "sel-inp-size",
                placeholder: "Please select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roundList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: item }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_entity_selector, {
                value: _ctx.query.entity,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.entity) = $event)),
                ref: "entityRef",
                isDefault: true
              }, null, 8, ["value"])
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_a_button, {
              style: {"margin-right":"15px"},
              onClick: _ctx.reset
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.search
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", {
            class: _normalizeClass(["font_family icon-xiazai m-l-20", {'disabled': !_ctx.query.payoutRound}]),
            style: {"font-size":"24px"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDownload && _ctx.handleDownload(...args)))
          }, null, 2),
          _createElementVNode("span", {
            class: "font_family icon-shoucang m-l-20",
            style: {"font-size":"24px"},
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showFavorite && _ctx.showFavorite(...args)))
          }),
          _createElementVNode("span", {
            class: "font_family icon-shezhi m-l-20",
            style: {"font-size":"24px"},
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveFavorite && _ctx.saveFavorite(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_a_collapse, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeKey) = $event)),
            expandIconPosition: "right"
          }, {
            expandIcon: _withCtx(({ isActive }) => [
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_RightOutlined, {
                  rotate: isActive ? 90 : 0
                }, null, 8, ["rotate"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, { key: "1" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", null, _toDisplayString(_ctx.NormalDelearData
                            ? _ctx.toThousandsAndTwoDecimal(
                                _ctx.RiskDelearData?.totalAmountWOVat
                              )
                            : 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", null, _toDisplayString(_ctx.NormalDelearData
                            ? _ctx.toThousandsAndTwoDecimal(
                                _ctx.RiskDelearData?.totalAmountWVat
                              )
                            : 0), 1)
                      ])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_collapse_table, {
                    column: _ctx.column,
                    data: _ctx.RiskDelearData
                  }, null, 8, ["column", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, { key: "2" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", null, _toDisplayString(_ctx.NormalDelearData
                            ? _ctx.toThousandsAndTwoDecimal(
                                _ctx.NormalDelearData?.totalAmountWOVat
                              )
                            : 0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", null, _toDisplayString(_ctx.NormalDelearData
                            ? _ctx.toThousandsAndTwoDecimal(
                                _ctx.NormalDelearData?.totalAmountWVat
                              )
                            : 0), 1)
                      ])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_collapse_table, {
                    column: _ctx.column,
                    data: _ctx.NormalDelearData
                  }, null, 8, ["column", "data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey"])
        ])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      title: "My Favorite",
      closable: true,
      visible: _ctx.isFavoriteVisible,
      width: "35.14%",
      class: "upload-drawer claim-drawer",
      onClose: _ctx.closeFavorite
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: _ctx.favoriteColumns,
          pagination: false,
          dataSource: _ctx.favoriteData,
          customRow: _ctx.customRow,
          rowKey: "id",
          bordered: ""
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("a", null, [
              _createElementVNode("span", {
                class: "font_family",
                style: {"font-size":"16px"},
                onClick: _withModifiers(($event: any) => (_ctx.deleteFavorite(record)), ["stop"])
              }, " Delete ", 8, _hoisted_39)
            ])
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "customRow"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ]))
}